import React from "react";
import { useSelector } from "react-redux";

import TimePeriodSelector from "../../../../components/charts/timePeriodSelector/TimePeriodSelector";
import { getShowDrilldownPeriod } from "../../../../store/config.selectors";
import { ReportsPeriod } from "../../../../helpers/reports.helper.types";

interface TimePeriodProps {
  period: ReportsPeriod;
  onTimePeriodChange: (period: ReportsPeriod) => void;
}

export const DrilldownTimePeriod = ({
  period,
  onTimePeriodChange,
}: TimePeriodProps) => {
  const showDrilldownPeriod = useSelector(getShowDrilldownPeriod);

  return (
    <TimePeriodSelector
      showSelector={showDrilldownPeriod}
      period={period}
      onChange={onTimePeriodChange}
    />
  );
};
